import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import './App.css';

// Pages
import Dashboard from './pages/Dashboard';
import Items from './pages/Items';
import ItemDetail from './pages/ItemDetail';
import ScanQR from './pages/ScanQR';
import AdminPanel from './pages/AdminPanel';
import Students from './pages/Students';
import NotFound from './pages/NotFound';
import AdminLogin from './pages/AdminLogin';
import MyReservations from './pages/MyReservations';

// Auth Components
import Login from './components/auth/Login';

// Utils
import { resetExpiredCheckouts } from './utils/itemOperations';

// Admin route protection component
const AdminRoute = ({ children }) => {
  const { currentUser, userDetails, loading } = useAuth();

  // Show loading while checking auth state
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="text-lg">Loading...</div>
        </div>
      </div>
    );
  }

  // Check if user is authenticated and has admin role
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  // Wait for userDetails to load before checking role
  if (!userDetails) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="text-lg">Loading user details...</div>
        </div>
      </div>
    );
  }

  if (userDetails.role !== 'admin') {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

// Note: LoadingScreen removed as it's not currently being used

function App() {
  // Run auto-reset for expired checkouts on app load
  useEffect(() => {
    const checkExpiredCheckouts = async () => {
      try {
        const resetItems = await resetExpiredCheckouts();
        if (resetItems.length > 0) {
          console.log('Auto-reset expired checkouts:', resetItems);
        }
      } catch (error) {
        console.error('Error checking expired checkouts:', error);
      }
    };

    checkExpiredCheckouts();
  }, []);

  return (
    <Router>
      <Routes>
        {/* Auth Routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Navigate to="/login" replace />} />
        
        {/* Public Routes */}
        <Route path="/" element={<Navigate to="/dashboard" />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/items" element={<Items />} />
        <Route path="/item/:itemId" element={<ItemDetail />} />
        <Route path="/scan" element={<ScanQR />} />
        <Route path="/my-reservations" element={<MyReservations />} />
        
        {/* Admin Routes */}
        <Route path="/admin" element={<Navigate to="/login" replace />} />
        <Route path="/admin-login" element={<Navigate to="/login" replace />} />
        <Route path="/admin-panel" element={<AdminRoute><AdminPanel /></AdminRoute>} />
        <Route path="/students" element={<AdminRoute><Students /></AdminRoute>} />
        
        {/* Catch All Route */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;